import { gql } from '@apollo/client';

export const HEARTBEAT = gql`
  mutation HEARTBEAT($heartbeatInput: HeartbeatInput!) {
    heartbeatV2(heartbeatInput: $heartbeatInput) {
      sessionExtendedStatus
      encounterPublished
      boothStaffAvailabilityHeartbeatStatus
    }
  }
`;

export const UPDATE_PROFILE_SECURED = gql`
  mutation UPDATE_PROFILE_SECURED($profile: ProfileSecuredUpdateInput!, $locale: String) {
    updateProfileSecured(profile: $profile, locale: $locale) {
      id
      prefix
      firstName
      lastName
      designation
      company
      title
      headline
      bio
      pronouns
      address(locale: $locale) {
        country
        countryCode
        city
        region
        regionCode
      }
      facebookUrl
      twitterUrl
      linkedInUrl
      websiteUrl
      visibility
      allowPushNotifications
      allowAppointmentPushNotifications
    }
  }
`;

export const UPDATE_PROFILE_SECURED_WITH_INTERESTS = gql`
  mutation UPDATE_PROFILE_SECURED($profile: ProfileSecuredUpdateInput!, $locale: String) {
    updateProfileSecured(profile: $profile, locale: $locale) {
      id
      prefix
      firstName
      lastName
      designation
      company
      title
      headline
      bio
      pronouns
      address(locale: $locale) {
        country
        countryCode
        city
        region
        regionCode
      }
      facebookUrl
      twitterUrl
      linkedInUrl
      websiteUrl
      professionalInterests @appFeature(feature: "attendeeInterests") {
        id
        text
        commonInterest
      }
      visibility
      allowPushNotifications
      allowAppointmentPushNotifications
    }
  }
`;

export const UPDATE_PROFILE_PHOTO = gql`
  mutation UPDATE_PROFILE_PHOTO($eventId: String, $input: File!) {
    updateProfilePhotoResponse(eventId: $eventId, input: $input)
      @rest(path: "/api/profile/photo-upload?eventId={args.eventId}", method: "POST", bodySerializer: "fileEncode") {
      noResponse
    }
  }
`;

export const LOGOUT = gql`
  mutation LOGOUT($input: LogoutInput!) {
    logout(input: $input) {
      revokeStreamTokens
    }
  }
`;

export const UPDATE_ATTENDEE_COMPLIANCE = gql`
  mutation UPDATE_ATTENDEE_COMPLIANCE {
    updateAttendeeCompliance {
      requestReceived
    }
  }
`;
